<template>
	<aside v-if="ad" class="faq-category-ad">
		<a 
			:href="ad.url" target="_blank">
			<img :src="ad.src" :alt="ad.alt" />
		</a>
	</aside>
</template>

<script>
export default {
	props: {
		ad: {
			type: Object,
			required: true,
		},
	},
};
</script>
